/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/*
 * Pulled from sarsa
 */

/* eslint-disable react/no-did-update-set-state */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { ScreenReaderTip, Icon, announce } from 'sarsaparilla';
import { GridHeaderCell } from './Grid';

export default class SortableTableColumnHeader extends React.PureComponent {
    static propTypes = {
        name: PropTypes.string,
        id: PropTypes.string,
        isSorted: PropTypes.bool,
        isAsc: PropTypes.bool,
        onSortToggle: PropTypes.func,
        isDisabled: PropTypes.bool,
    };

    static defaultProps = {
        name: '',
        id: '',
        isSorted: false,
        isAsc: null,
    };

    constructor(props) {
        super(props);

        this.state = {
            isSorted: props.isSorted,
            isAsc: props.isAsc,
        };
    }

    componentDidUpdate(prevProps) {
        const { isSorted, isAsc } = this.props;

        if (isSorted !== prevProps.isSorted) {
            this.setState({ isSorted });
        }

        if (isAsc !== this.state.isAsc) {
            this.setState({ isAsc });
        }
    }

    onSortToggle = () => {
        const isAsc = !this.state.isAsc;

        announce(`Sorted by ${this.props.name}: ${isAsc ? 'ascending' : 'descending'}`);

        if (this.state.isSorted) {
            this.setState(
                {
                    isAsc,
                },
                () => {
                    this.props.onSortToggle(
                        this.state.isSorted,
                        this.state.isAsc,
                        this.props.id
                    );
                }
            );
        } else {
            this.setState(
                {
                    isSorted: true,
                    isAsc: true,
                },
                () => {
                    this.props.onSortToggle(
                        this.state.isSorted,
                        this.state.isAsc,
                        this.props.id
                    );
                }
            );
        }
    };

    render() {
        const { isDisabled } = this.props;
        const { isSorted, isAsc } = this.state;

        let sort = 'none';
        if (isSorted) {
            sort = isAsc ? 'ascending' : 'descending';
        }

        return (
            <GridHeaderCell
                className="sortable-column-header"
                aria-sort={sort}
                role="columnheader"
            >
                <ScreenReaderTip content="Click to sort the table by this column">
                    <button
                        type="button"
                        data-testid="sortable-table-column-header"
                        onClick={this.onSortToggle}
                        disabled={isDisabled}
                    >
                        <span className="title">{this.props.name}</span>
                        <div className="sort">
                            <div
                                className={cx({
                                    disabled: isSorted && isAsc,
                                    sorted: isSorted && !isAsc,
                                    enabled: !isSorted,
                                })}
                            >
                                <Icon iconName="arrow-up" />
                            </div>
                            <div
                                className={cx({
                                    disabled: isSorted && !isAsc,
                                    sorted: isSorted && isAsc,
                                    enabled: !isSorted,
                                })}
                            >
                                <Icon iconName="arrow-down" />
                            </div>
                        </div>
                    </button>
                </ScreenReaderTip>
            </GridHeaderCell>
        );
    }
}
